
export const haversineDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const dLat = (lat2 - lat1) * Math.PI / 180.0;
    const dLon = (lon2 - lon1) * Math.PI / 180.0;

    // convert to radians
    lat1 = (lat1) * Math.PI / 180.0;
    lat2 = (lat2) * Math.PI / 180.0;

    // apply formulae
    const a = Math.pow(Math.sin(dLat / 2), 2) +
        Math.pow(Math.sin(dLon / 2), 2) *
        Math.cos(lat1) *
        Math.cos(lat2);
    const rad = 6371;
    const c = 2 * Math.asin(Math.sqrt(a));
    
    return rad * c;
};

export const calulateMiles = (lat1: number, lon1: number, lat2: number, lon2: number) => {

   const kms =  haversineDistance(lat1, lon1, lat2, lon2);

   const miles = kms * 0.6213711;

   return miles;
}
